import { render } from "./AccordionItem.vue?vue&type=template&id=793a8ca5"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=793a8ca5&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__